import { createContext, useContext, useEffect, useState } from "react";
import { translations } from "./translations";

const I18nCtx = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("sp_lang") || "en");

  useEffect(() => {
    localStorage.setItem("sp_lang", lang);
    document.body.setAttribute("data-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (key) => {
    const dict = translations[lang] || translations.en;
    return dict[key] ?? translations.en[key] ?? key;
  };

  const toggle = () => setLang((l) => (l === "en" ? "km" : "en"));

  return (
    <I18nCtx.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </I18nCtx.Provider>
  );
}

export function useI18n() {
  const ctx = useContext(I18nCtx);
  if (!ctx) throw new Error("useI18n must be used in I18nProvider");
  return ctx;
}
